
// USAGE
// import isMobile from './is-mobile';
// isMobile();

export default function isMobile() {
  // GET LESS VARS
  var mobile = true;
  var style = getComputedStyle(document.body);
  var breakPoint = style.getPropertyValue('--break');
  if (jQuery(window).width() > breakPoint) {
    mobile = false;
  }

  return mobile;
}

export function isMobileMid() {
  // GET LESS VARS
  var mobile = true;
  var style = getComputedStyle(document.body);
  var breakPoint = style.getPropertyValue('--breakMid');
  if (jQuery(window).width() > breakPoint - 1) {
    mobile = false;
  }

  return mobile;
}
